import * as React from 'react';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {Button} from 'shells/button/button';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import type {CalendarSync} from 'nutshell-graphql-types';

import {CalendarConnectButtons} from '../calendar-connect-buttons';
import {CALENDAR_BULLET_POINTS} from '../consts';

import {CalendarModalPage} from './calendar-modal-page';

type Props = {
    calendarSync: CalendarSync | null | undefined;
    refetch: () => Promise<any>;
    onCancel: () => void;
    nextPage: () => void;
};

export function CalendarGetStarted(props: Props) {
    const [errorMessages, setErrorMessages] = React.useState<string[]>([]);

    return (
        <CalendarModalPage
            header='Setting up your calendar'
            navButtons={
                <Button variant='text' size='big' onClick={props.onCancel}>
                    Cancel
                </Button>
            }
        >
            <Stack spacing={12}>
                <Body size='large' color='dark' isBold={true}>
                    Keep your calendar in sync with Nutshell
                </Body>
                <BulletedList bullets={CALENDAR_BULLET_POINTS} />
                <CalendarConnectButtons
                    calendarSync={props.calendarSync}
                    refetchSyncStatus={props.refetch}
                    errorMessages={errorMessages}
                    setErrorMessages={setErrorMessages}
                    onAuthSuccess={() => {
                        props.nextPage();
                    }}
                    isFullWidth={true}
                />
                {errorMessages.length > 0 &&
                    errorMessages.map((message) => (
                        <Body color='error' key={message}>
                            {message}
                        </Body>
                    ))}
            </Stack>
        </CalendarModalPage>
    );
}
